import React, { useEffect, useState } from 'react';
import { Wrapper } from '../../../components/Wrapper';
import { If, Then, Else } from 'react-if';
import PelatihanController, {
  usePelatihanContext,
} from '../../../controller/pelatihan/index';
import PelatihanSayaController, {
  usePelatihanSayaContext,
} from '../../../controller/registered/pelatihan_saya';
import { Pelatihan } from '../../../../../entities/Pelatihan';
import ReactPaginate from 'react-paginate';
import { ToastContainer } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';
import { useIsAuthenticated } from 'react-auth-kit';
import { checkAndRedirectToProfile } from '../../../../utils/authUtils';
import {
  Box,
  Text,
  Flex,
  Grid,
  Icon,
  useBreakpointValue,
  Container,
  VStack,
} from '@chakra-ui/react';
import { FaBookOpen } from 'react-icons/fa';

import JoyrideComponent from '../../../components/global/Joyride';
import { Placement } from 'react-joyride';
import CardItemPelatihan from '../../../components/global/Card/CardItemPelatihan';
import ShapeHeroPelatihan from '../../../assets/webp/shape-hero-pelatihan.webp';

const HeroPelatihan: React.FC = () => {
  const { searchPelatihan } = usePelatihanContext();
  const { keyword } = usePelatihanContext().state;

  const [searchInput] = useState(keyword);

  const isMobile = useBreakpointValue({ base: true, md: false });

  useEffect(() => {
    const handler = setTimeout(() => {
      searchPelatihan(searchInput);
    }, 500);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInput]);

  return (
    <>
      <Box
        w="100%"
        bg="#15803D"
        color="white"
        position="relative"
        overflow="hidden"
      >
        {!isMobile && (
          <Box
            position="absolute"
            top="0"
            right="0"
            h="100%"
            w={{ base: '200px', md: '400px' }}
            backgroundImage={`url(${ShapeHeroPelatihan})`}
            backgroundRepeat="no-repeat"
            backgroundPosition="right top"
            backgroundSize="contain"
            pointerEvents="none"
          />
        )}

        <Container maxW={{ base: '100%', md: '1512px' }} px="60px">
          <VStack spacing="24px" py="60px" align="center" textAlign="center">
            <Box
              w="60px"
              h="60px"
              bg="white"
              borderRadius="8px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon as={FaBookOpen} boxSize={8} color="#15803D" />
            </Box>

            <Text
              fontSize={{ base: '18px', md: '24px' }}
              fontWeight="700"
              lineHeight="1.3"
            >
              Temukan Pelatihan Untuk Tingkatkan Kompetensi Anda
            </Text>
          </VStack>
        </Container>
      </Box>

      {/* <Box
        position="relative"
        backgroundImage={`url(${BgNewPintar})`}
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        py={[10, 10, 16]}
      >
        <Box maxW="1200px" mx="auto" px={[4, 4, 8]}>
          <Box bg="white" p={[4, 4, 8]} borderRadius="xl" boxShadow="lg">
            <Box mb={6} position="relative">
              <Input
                placeholder="Cari disini..."
                fontSize="16px"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                size="lg"
                pr="40px"
              />
              <Box
                position="absolute"
                right="12px"
                top="50%"
                transform="translateY(-50%)"
              >
                <FaSearch color="green" />
              </Box>
            </Box>

            <Grid
              templateColumns={{
                base: 'repeat(1, 1fr)',
                md: 'repeat(3, 1fr)',
              }}
              gap={4}
              alignItems="end"
            >
              <Box>
                <Text mb={2} fontSize="16px" fontWeight="medium">
                  Jenjang
                </Text>
                <Select
                  placeholder="Pilih jenjang"
                  value={jenjang}
                  fontSize="16px"
                  onChange={(e) => {
                    filterJenjang(e.target.value);
                  }}
                >
                  {jenjangList.map((item) => (
                    <option key={item.jenjang} value={item.jenjang}>
                      {item.jenjang}
                    </option>
                  ))}
                </Select>
              </Box>

              <Box>
                <Text mb={2} fontSize="16px" fontWeight="medium">
                  Tipe
                </Text>
                <Select
                  placeholder="Pilih Tipe"
                  value={jenis_pelatihan_id}
                  fontSize="16px"
                  onChange={(e) => {
                    filterJenisPelatihan(e.target.value);
                  }}
                >
                  {subMenuJenisPelatihan.map((s, key) => (
                    <option value={s.id} key={key}>
                      {s.judul_menu}
                    </option>
                  ))}
                </Select>
              </Box>

              <Box>
                <Button
                  bg={'green.900'}
                  color={'white'}
                  w="full"
                  type="button"
                  fontSize="16px"
                  onClick={handleResetFilter}
                  _hover={{ bg: 'green.800' }}
                >
                  Reset Filter
                </Button>
              </Box>
            </Grid>
          </Box>
        </Box>
      </Box> */}
    </>
  );
};

const Pagination = () => {
  const { setPage } = usePelatihanContext();
  const { jumlahPage } = usePelatihanContext().state;

  var endFix =
    jumlahPage > Number(jumlahPage.toFixed())
      ? Number(jumlahPage.toFixed()) + 1
      : Number(jumlahPage.toFixed());

  const handlePageClick = (event) => {
    setPage(event.selected);
  };

  return (
    <If condition={endFix > 1}>
      <Then>
        <div className="flex justify-center mt-5">
          <ReactPaginate
            breakLabel="..."
            nextLabel="Selanjutnya"
            activeClassName="active"
            containerClassName="pagination"
            onPageChange={handlePageClick}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            pageCount={
              jumlahPage > Number(jumlahPage.toFixed())
                ? Number(jumlahPage.toFixed()) + 1
                : Number(jumlahPage.toFixed())
            }
            previousLabel="Sebelumnya"
          />
        </div>
      </Then>
      <Else>
        <></>
      </Else>
    </If>
  );
};

const GuidePelatihan = () => {
  const steps = [
    {
      content: (
        <p>
          Search Pelatihan: Temukan pelatihan menarik yang bisa kamu ikuti
          disini
        </p>
      ),
      placement: 'bottom' as Placement,
      target: '#search-pelatihan',
      disableBeacon: true,
    },
    {
      content: (
        <p>
          Lihat selengkapnya: Lihat dan baca informasi pelatihan, klik disini
        </p>
      ),
      placement: 'top' as Placement,
      target: '.group:nth-child(1) .btn-pelatihan div',
      disableBeacon: true,
    },
  ];
  return (
    <Box mt={{ base: 4, md: 0 }}>
      <JoyrideComponent steps={steps} />
    </Box>
  );
};

const ListPelatihan: React.FC = () => {
  const { pelatihan, isLoading } = usePelatihanContext().state;
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box mx={8} my={10}>
      {isMobile && <GuidePelatihan />}
      <Box mt={8} ml={{ base: 0, md: 4 }}>
        <If condition={isLoading}>
          <Then>
            <Skeleton
              count={4}
              style={{ height: '400px', width: '280px', marginRight: '20px' }}
              inline={true}
            />
          </Then>
          <Else>
            <If condition={pelatihan.length > 0}>
              <Then>
                <Grid
                  gap={8}
                  templateColumns={{
                    base: 'repeat(1fr)',
                    sm: 'repeat(2, 1fr)',
                    md: 'repeat(4, 1fr)',
                  }}
                >
                  {pelatihan.map((v: Pelatihan) => (
                    <CardItemPelatihan pelatihan={v} key={v.id} />
                  ))}
                </Grid>
              </Then>
              <Else>
                <div className="text-center mt-20">
                  <h1 className="text-xl text-gray-400">Belum Ada Pelatihan</h1>
                </div>
              </Else>
            </If>
          </Else>
        </If>
        <Flex justifyContent="center">
          <Pagination />
        </Flex>
      </Box>
    </Box>
  );
};

const WrapperMain: React.FC = () => {
  const { getSubMenuJenisPelatihan, getJenjang } = usePelatihanContext();
  const { getCurrentDateServer } = usePelatihanSayaContext();

  // use is authenticated
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    getCurrentDateServer().then(() => {
      getSubMenuJenisPelatihan();
      getJenjang();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    checkAndRedirectToProfile(isAuthenticated());
  }, [isAuthenticated]);

  return (
    <Wrapper>
      <HeroPelatihan />

      {/* List Pelatihan */}
      <ListPelatihan />
    </Wrapper>
  );
};

const PelatihanList: React.FC = () => {
  return (
    <PelatihanController.Provider>
      <PelatihanSayaController.Provider>
        <ToastContainer
          position="top-center"
          style={{ width: '60%', marginTop: '5%' }}
        />
        <WrapperMain />
      </PelatihanSayaController.Provider>
    </PelatihanController.Provider>
  );
};

export default PelatihanList;
